import { AutorizationVM, ServicesVM } from './types';
import { HeadCell } from 'shell/components/shared/table/types';

export const head: HeadCell<AutorizationVM, keyof AutorizationVM>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'type',
    label: 'Autorizzazione',
  },
  {
    id: 'value',
    label: 'Valore',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const headServices: HeadCell<ServicesVM, keyof ServicesVM>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'service',
    label: 'Servizi',
  },
  {
    id: 'action',
    label: '',
  },
];

export const FEATURE_AUTHORIZATION_ANPR = 29;

export enum OperatorType {
  InternalOperator = '1',
  ExternalOperator = '2',
}

export const ANPR_ACCORDION_EVENT = 'accordion-anpr-change-event';
